import { ErrorResponse } from '@partnerconnect-monorepo/types/ErrorResponse';
import { InfoBanner } from '@partnerconnect-monorepo/types/info-banner/InfoBanner';
import { axios } from '../../lib/core/AxiosInterceptor/AxiosInterceptor';
import { mapToCamelCase } from '../../lib/helpers/helpers';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const getReportingInfoBanner = () =>
  axios
    .get(`${import.meta.env.VITE_REPORTING_APP_BE_BASE}/infobanner/`)
    .then<Array<InfoBanner>>((res) => mapToCamelCase(res.data))
    .catch(() => []);

export const useReportingInfoBanner = (
  options: Partial<
    UseQueryOptions<
      Array<InfoBanner>,
      AxiosError<ErrorResponse>,
      Array<InfoBanner>,
      [string]
    >
  > = {}
) =>
  useQuery({
    queryKey: ['REPORTING_INFOBANNER'],
    queryFn: getReportingInfoBanner,
    ...options
  });
